import { PetType, PetTypeIds } from '@spike/model';
import clsx from 'clsx';
import { FunctionComponent, useMemo } from 'react';
import PetTypeTag from './PetTypeTag';
import styles from './PetTypeTags.module.scss';

interface PetTypeTagsProps {
    petTypes: Array<PetType>;
    className?: string;
}
const sortTable = new Map<string, number>([
    [PetTypeIds.DOGS.toString(), 1],
    [PetTypeIds.CATS.toString(), 2],
    [PetTypeIds.EXOTICS.toString(), 3]
]);
export const PetTypeTags: FunctionComponent<PetTypeTagsProps> = props => {
    const sortedPetTypes = useMemo(
        () =>
            props.petTypes.sort(
                (petType, otherPetType) => (sortTable.get(petType.id) ?? 10) - (sortTable.get(otherPetType.id) ?? 10)
            ),
        [props.petTypes]
    );

    return (
        <div className={clsx(styles.container, props.className)}>
            {sortedPetTypes.map(petType => (
                <PetTypeTag
                    key={petType.id}
                    petType={petType}
                />
            ))}
        </div>
    );
};

export default PetTypeTags;
